// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getBrandInCaps, getIconPath } from '@tcp/core/src/utils/utils';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import withStyles from '../../../hoc/withStyles';
import styles, { FOOTER } from '../styles/SMSTapToJoin.style';
import { SNJ_SECONDARY_FILL_WHITE } from '../../../../../constants/brandSpecific.constants';

const getSMSText = (page, label) => {
  const dynamicLabel = getDynamicLabelValues(`dynamic.global_d.lbl_${page}_${label}`);
  const defaultLabel = `lbl_${page}_${label}`;
  return dynamicLabel !== defaultLabel
    ? dynamicLabel
    : getLabelFromCopyOrFromTranslation(`global.emailSignup.${defaultLabel}`);
};

const renderBodyText = (isFooterPage, SMSUserText1, SMSUserText2) => {
  return (
    <div className="tap-to-join-text-copy">
      {SMSUserText1 && (
        <BodyCopy
          component={isFooterPage ? 'span' : 'div'}
          color={isFooterPage ? 'gray.800' : 'gray.900'}
          fontWeight={isFooterPage ? 'black' : 'extrabold'}
          fontFamily="primary"
          fontSize="fs14"
          className="sms_body_text_join"
          dataLocator="sms_promo_text"
        >
          {SMSUserText1}
        </BodyCopy>
      )}
      <BodyCopy
        component="span"
        fontFamily="primary"
        fontWeight={isFooterPage ? 'black' : 'extrabold'}
        fontSize={isFooterPage ? 'fs14' : 'fs32'}
        className="sms_body_text_off"
        dataLocator="sms_promo_text"
      >
        {SMSUserText2}
      </BodyCopy>
    </div>
  );
};
const SMSTapToJoin = (props) => {
  const smsButtonLabelText = getDynamicLabelValues('dynamic.global_d.lbl_sms_button_text');

  const { className, smsFromPage, isFooterRedesignEnabled } = props;
  const SMSUserText1 = getSMSText(smsFromPage, 'SMS_userText1');
  const SMSUserText2 = getSMSText(smsFromPage, 'SMS_userText2');
  const SMSUserText3 = getSMSText(smsFromPage, 'SMS_userText3');
  const SMSNumber = getSMSText(smsFromPage, 'SMS_textNumber');
  const SMSBody = getSMSText(smsFromPage, 'SMS_bodyText');

  const smsTemplate = `sms:${SMSNumber}?&body=${SMSBody}`;
  const isFooterPage = smsFromPage === FOOTER;

  return (
    <div className={className}>
      <div className="tap-to-join-wrapper">
        {!isFooterPage && (
          <Image
            src={getIconPath('blue-sms-icon')}
            className="tap-to-join-blue-image"
            alt="tcp to join"
          />
        )}
        {renderBodyText(isFooterPage, SMSUserText1, SMSUserText2)}
      </div>
      {isFooterPage && !isFooterRedesignEnabled && (
        <Image
          src={getIconPath('black-sms-icon')}
          className="tap-to-join-black-image"
          alt="tcp to join"
        />
      )}
      {!isFooterPage && (
        <BodyCopy
          component="div"
          fontFamily="secondary"
          fontWeight="normal"
          fontSize="fs14"
          className="sms_body_text_extra"
          dataLocator="sms_promo_text"
        >
          {SMSUserText3}
        </BodyCopy>
      )}
      <div id="vibes_tap2join_box">
        <div className="button-container">
          <a href={smsTemplate} className="anchor">
            <Button
              buttonVariation="variable-width"
              fill={SNJ_SECONDARY_FILL_WHITE[`${getBrandInCaps()}`]}
              className="tapToJoin-cta"
            >
              {smsButtonLabelText}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

SMSTapToJoin.propTypes = {
  className: PropTypes.string,
  smsFromPage: PropTypes.string,
};

SMSTapToJoin.defaultProps = {
  className: '',
  smsFromPage: 'footer',
};

export default withStyles(SMSTapToJoin, styles);

export { SMSTapToJoin as SMSTapToJoinVanilla };
